import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  GetViewingsInsightsRequestPayload,
  GetViewingsInsightsSuccess,
  ViewingsInsightsState,
} from '@redux/types/insights/viewings-insights/viewingsInsightsTypes';

const storeName = 'viewingsInsights';

const initialState: ViewingsInsightsState = {
  error: null,
  loading: false,
  reports: [],
  societiesInvalid: false,
};

const viewingsInsightsSlice = createSlice({
  name: storeName,
  initialState,
  reducers: {
    setListLoading(state: ViewingsInsightsState, action: PayloadAction<boolean>) {
      state.error = null;
      state.loading = action.payload;
      state.reports = [];
      state.societiesInvalid = false;
      state.meta = undefined;
    },
    setListSocietiesInvalid(state: ViewingsInsightsState, action: PayloadAction<boolean>) {
      state.societiesInvalid = action.payload;
    },
    getListSuccess(state: ViewingsInsightsState, action: PayloadAction<GetViewingsInsightsSuccess>) {
      state.loading = false;
      state.reports = action.payload.data;
      state.meta = action.payload.meta;
    },
    getListFailure(state: ViewingsInsightsState, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const viewingsInsightsActions = {
  setListLoading: viewingsInsightsSlice.actions.setListLoading,
  setListSocietiesInvalid: viewingsInsightsSlice.actions.setListSocietiesInvalid,
  getListSuccess: viewingsInsightsSlice.actions.getListSuccess,
  getListFailure: viewingsInsightsSlice.actions.getListFailure,
  getListRequest: createAction<GetViewingsInsightsRequestPayload>(`${storeName}/getListRequest`),
};

export const viewingsInsightsReducer = viewingsInsightsSlice.reducer;
